import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

// Скриншоты устройств: снимки крона и кадры задач ОДНИМ списком с общим device_id
// (authorized/admin/screenshots). Отдельно от files намеренно — там снимки лежат вперемешку с
// apk и об устройстве не знают: у снимка крона привязки нет вовсе (ссылка пишется только в
// devices.screenshot_file_id и указывает на ПОСЛЕДНИЙ), у кадра задачи она через две таблицы.
// См. докблок ScreenshotsController на бэкенде.
//
// Read-only: снимки заводят крон и скрипты, create/update/destroy на бэкенде нет.
export class ScreenshotFormatter extends Formatter {
    // device_id/source/name/public_url/execute_id/dir/size отдаём как есть;
    // id/created_at/updated_at нормализует базовый Formatter.Item.
}

export default class ApiScreenshot extends ApiModelWithAuth {
    pathDef = 'authorized/admin/screenshots';
    formatterItem = ScreenshotFormatter.Item;

    // Страница крупнее дефолтных 20: список показывается плиткой, и 20 карточек не заполняют
    // даже один экран (потолок бэкенда — 200, ScreenshotsController::PER_PAGE_MAX).
    // per_page ставим ЗДЕСЬ, а не в searchParams списка: там он попал бы в счётчик активных
    // фильтров (ProviderList::activeFiltersCount), и панель всегда показывала бы «1 фильтр».
    static Index(params = {}) {
        return super.Index({ per_page: 48, ...params });
    }
}
